import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  ChangeDetectorRef,
  EventEmitter,
  Output,
  ViewChild,
} from '@angular/core'
import { ShoppingCartService } from '../cart.service'
import {
  AuthService,
  GlobalMessageService,
  GlobalMessageType,
} from '@spartacus/core'
import { combineLatest, Observable, of, Subscription } from 'rxjs'
import { ShoppingCart } from '../cart.model'
import moment from 'moment'
import { LaunchDialogService } from '@spartacus/storefront'
import { Item } from '../cart-item/cart-item.component'
import { Actions, ofType } from '@ngrx/effects'
import { filter, switchMap, take } from 'rxjs/operators'
import { ActiveCartFacade, MultiCartFacade } from '@spartacus/cart/base/root'
import { CartActions } from '@spartacus/cart/base/core'

import { UserAccountFacade } from '@spartacus/user/account/root'
import { OrderType } from '../../../../models/status/status.model'
import { SpinnerOverlayService } from '../../../../shared/components/spinner-overlay/spinner-overlay.service'
import { CalenderConfigService } from '../../../../shared/services/calender-config.service'
import { DialogResponse, VS_LAUNCH_CALLER } from '../../../config/dialog.config'
import { CheckoutService } from '../../checkout/checkout/checkout.service'
import { DatePickerComponent } from '../../../../shared/components/date-picker/date-picker.component'

@Component({
  standalone: false,

  selector: 'vs-order-actions',
  templateUrl: './order-actions.component.html',
  styleUrls: ['./order-actions.component.scss'],
})
export class OrderActionsComponent implements OnInit, OnDestroy {
  userId = 'current'
  cartId$: Observable<string> = this.activeCartFacade.getActiveCartId()
  orderType = 'For Resale'
  cartId: string

  @ViewChild('consShipTrue')
  consShipTrue

  @ViewChild('consShipFalse')
  consShipFalse

  @ViewChild('applyAllDatePicker')
  applyAllDatePicker: DatePickerComponent

  @Input()
  userType = 'current'

  @Input()
  cart$: Observable<ShoppingCart>

  @Output()
  scrollToEntry: EventEmitter<any> = new EventEmitter()

  @Output()
  updateCart: EventEmitter<any> = new EventEmitter()
  cartSubscription: any

  isPartialSubscription: any
  defaultHeaderDateSubscription: any

  cart: ShoppingCart

  items: Item[]

  // orderType$: Observable<any> = this.shoppingCartService.getOrderType(this.userType);
  minDate = new Date()
  defaultHeaderDate
  rfqType = 'Resale'
  orderTypes: any
  orderTypes$: Observable<any>
  soldToAddress$: Observable<any>
  requestedShipDateString = ''
  showShipDateLoader = false
  completeOrderDialog
  consShipDateApplyError = false
  proceedClicked: boolean = false
  // salesOrderCommmission: boolean = false;
  commissionEligibleDisplay: boolean = false
  commissionModel: boolean = false
  soldToAddress = null
  orderTypeEnum = OrderType
  orderTypeValue: any = 'Resale'
  quoteCartType: any = ''
  activeCartSubscription: Subscription
  checkoutGetCartSubscription: Subscription
  cartResponse: any
  soldToAddresses: any
  filterWeekend = this.calenderConfigService.isFilterWeekend()
  selectedDay
  dayOfWeek = [
    'sunday',
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
  ]
  user$: any
  constructor(
    private activeCartFacade: ActiveCartFacade,
    private shoppingCartService: ShoppingCartService,
    private multiCartFacade: MultiCartFacade,
    private globalMessageService: GlobalMessageService,
    private launchDialogService: LaunchDialogService,
    private spinnerOverlayService: SpinnerOverlayService,
    private cRef: ChangeDetectorRef,
    private checkoutService: CheckoutService,
    private actions$: Actions,
    private calenderConfigService: CalenderConfigService,
    private authService: AuthService,
    private userAccountFacade: UserAccountFacade
  ) {}

  ngOnInit(): void {
    this.activeCartSubscription = this.cartId$.subscribe(
      (success) => {
        if (success) {
          this.cartId = success
        }
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
    this.user$ = this.authService.isUserLoggedIn().pipe(
      switchMap((isUserLoggedIn) => {
        if (isUserLoggedIn) {
          this.userType = 'current'
          return this.userAccountFacade.get()
        } else {
          this.userType = 'anonymous'
          return of(undefined)
        }
      })
    )
    this.user$.subscribe((user) => {
      if (user) {
        this.orderTypes$ = this.shoppingCartService.getOrderType(this.userType)
        this.orderTypes$.subscribe((success) => {
          this.orderTypes = success['orderType']
          // this.rfqType = this.orderTypes[0].name;
        })
      }
    })
    this.soldToAddress$ = this.shoppingCartService.getSoldToAddress()
    this.soldToAddress$.subscribe((success) => {
      this.soldToAddresses = success
    })
    this.shoppingCartService.getClicked.subscribe((value) => {
      this.proceedClicked = value
    })
    this.shoppingCartService.soldToSelected(true)

    combineLatest()
    this.cartSubscription = this.cart$.subscribe(
      (res: any) => {
        this.cartResponse = res
        this.cart = Object.assign({}, res)
        if (this.cart?.isDifferentPlant) {
          this.globalMessageService.add(
            { key: 'savedCart.changedToPartial' },
            GlobalMessageType.MSG_TYPE_INFO,
            10000
          )
          window.scrollTo(0, 0)
        }
        if (this.cart.isConsolidatedShipment == true) {
          this.selectedDay = this.cart?.consolidatedDay
            ?.toLowerCase()
            .split(',')
        }
        if (this.cart?.quoteCartType) {
          this.globalMessageService.add(
            { key: 'savedCart.quoteConvertedToOrder' },
            GlobalMessageType.MSG_TYPE_INFO,
            20000
          )
          window.scrollTo(0, 0)
        }
        this.items = this.cart.entries
        this.shoppingCartService.setShippingType(this.cart.partialShipping)
        // this._cart = Object.assign({}, this.cart);

        if (this.cartResponse?.vsNonSellableProducts?.length > 0) {
          this.openNonSellableDialog()
        }
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )

    this.checkoutGetCartSubscription = this.checkoutService
      .getCart(this.cartId)
      .subscribe((success: any) => {
        this.commissionEligibleDisplay = success['showCheckBoxForCommission']
        this.commissionModel = success['isCommissionEligible']
        this.soldToAddresses?.b2bUnits.forEach((element) => {
          if (
            element?.uid == success?.salesCommissionUnitId &&
            success?.salesCommissionUnitId
          ) {
            this.soldToAddress = element?.name
          }
        })
        this.cRef.detectChanges()
        this.rfqType = success?.cartOrderType?.code
        this.orderTypeValue = success?.cartOrderType?.name
        this.cart.cartOrderType = success?.cartOrderType
        this.quoteCartType = success?.quoteCartType

        if (!success?.cartOrderType?.code) {
          this.rfqType = this.orderTypes[0]?.code
          this.orderTypeValue = this.orderTypes[0]?.name
        }
        if (this.rfqType) {
          this.sendOrderType(this.rfqType, true)
        } else {
          this.sendOrderType(this.orderTypeEnum.RESALE, true)
        }
      })

    this.isPartialSubscription =
      this.shoppingCartService.isShippingTypePartial$.subscribe(
        (res) => {
          if (this.cart.partialShipping != res) {
            this.cart.partialShipping = res
            this.cRef.detectChanges()
          }
        },
        (error) => {
          this.globalMessageService.add(
            error,
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )

    // if (this.cart.vsNonSellableProducts?.length > 0) {
    //   this.openNonSellableDialog();
    // }

    this.defaultHeaderDateSubscription =
      this.shoppingCartService.defaultCartHeaderDate$.subscribe((res) => {
        this.applyAllDatePicker?.resetDate()
      })
  }

  ngOnDestroy(): void {
    this.cartSubscription.unsubscribe()
    this.isPartialSubscription.unsubscribe()
    if (this.defaultHeaderDateSubscription) {
      this.defaultHeaderDateSubscription.unsubscribe()
    }
    if (this.activeCartSubscription) {
      this.activeCartSubscription.unsubscribe()
    }
    if (this.checkoutGetCartSubscription) {
      this.checkoutGetCartSubscription.unsubscribe()
    }
    this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_WARNING)
    this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_ERROR)
    this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_INFO)
  }

  onDateChange(e) {
    this.requestedShipDateString = moment(e).format('YYYY/MM/DD')
  }

  applyReqShipDate(shipDateParam?) {
    const reqShipDate = shipDateParam ? shipDateParam : this.requestedShipDateString;

    if(!reqShipDate){
      this.globalMessageService.add(
        { key: 'savedCart.selectShipDate' },
        GlobalMessageType.MSG_TYPE_ERROR,
        5000
      )

      return false;
    }

    this.shoppingCartService.isConsolidatedShipment$
      .subscribe(
        (res) => {
          this.cart.isConsolidatedShipment = res
          if (this.cart.isConsolidatedShipment) {
            const weekDayName = moment(reqShipDate).format('dddd')
            let selectedDay = this.cart.consolidatedDay
              ?.toLocaleLowerCase()
              .split(',')
            let weekDay = weekDayName.toLocaleLowerCase()
            if (!selectedDay.includes(weekDay)) {
              this.consShipDateApplyError = true
              return
            } else {
              this.consShipDateApplyError = false
              this.shoppingCartService.setConsErrors([])
            }
          } else {
            this.consShipDateApplyError = false
            this.shoppingCartService.setConsErrors([])
          }

          this.showShipDateLoader = true
          this.spinnerOverlayService.show()
          this.shoppingCartService
            .changeRequestShipDate(reqShipDate, this.userType, this.cart.code)
            .subscribe(
              (res) => {
                if (shipDateParam) {
                  this.shoppingCartService
                    .changeShippingType(
                      this.userId,
                      this.cartId,
                      'complete',
                      true
                    )
                    .subscribe((success: any) => {
                      this.multiCartFacade.loadCart({
                        userId: this.userType,
                        cartId: this.cart.code,
                        extraData: {
                          active: true,
                        },
                      })
                      this.actions$
                        .pipe(ofType(CartActions.LOAD_CART_SUCCESS))
                        .pipe(take(1))
                        .subscribe(
                          (s) => {
                            this.showShipDateLoader = false
                            this.spinnerOverlayService.hide()
                          },
                          (error) => {
                            this.spinnerOverlayService.hide()
                            this.globalMessageService.add(
                              error,
                              GlobalMessageType.MSG_TYPE_ERROR,
                              5000
                            )
                            window.scrollTo(0, 0)
                          }
                        )
                    })
                } else {
                  this.multiCartFacade.loadCart({
                    userId: this.userType,
                    cartId: this.cart.code,
                    extraData: {
                      active: true,
                    },
                  })
                  this.actions$
                    .pipe(ofType(CartActions.LOAD_CART_SUCCESS))
                    .pipe(take(1))
                    .subscribe(
                      (s) => {
                        this.showShipDateLoader = false
                        this.spinnerOverlayService.hide()
                      },
                      (error) => {
                        this.spinnerOverlayService.hide()
                        this.globalMessageService.add(
                          error,
                          GlobalMessageType.MSG_TYPE_ERROR,
                          5000
                        )
                        window.scrollTo(0, 0)
                      }
                    )
                }
              },
              (error: any) => {
                this.spinnerOverlayService.hide()
                this.showShipDateLoader = false
                this.globalMessageService.add(
                  { key: 'savedCart.errorWhileApplyingShipDate' },
                  GlobalMessageType.MSG_TYPE_ERROR,
                  10000
                )
              }
            )
        },
        (error) => {
          this.globalMessageService.add(
            error,
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )
      .unsubscribe()
  }

  sendOrderType(event, pageLoad?) {
    this.spinnerOverlayService.show()
    this.shoppingCartService
      .sendOrderType(this.userId, this.cartId, event)
      .subscribe((success) => {
        //if (!pageLoad) { // Comment Reason: Need to call Cart API after RSL API call for updating product price
        this.multiCartFacade.loadCart({
          cartId: this.cart.code,
          userId: this.userType,
          extraData: {
            active: true,
          },
        })
        this.actions$
          .pipe(ofType(CartActions.LOAD_CART_SUCCESS), take(1))
          .subscribe((success) => {
            this.spinnerOverlayService.hide()
          })
        // }
      })
  }

  changeShippingType(event) {
    const shippingType = event.target.value || 'partial'
    if (shippingType == 'complete') {
      this.cart.partialShipping = false
      this.shoppingCartService.setShippingType(false)
    } else {
      this.cart.partialShipping = true
      this.shoppingCartService.setShippingType(true)
    }

    this.spinnerOverlayService.show('Loading')
    this.shoppingCartService
      .changeShippingType(this.userId, this.cartId, shippingType, true)
      .subscribe(
        (success: any) => {
          this.spinnerOverlayService.hide()
          if (success?.differentAvailabilityCode == 1001) {
            this.globalMessageService.add(
              { key: 'savedCart.shipmentIsPossible' },
              GlobalMessageType.MSG_TYPE_ERROR,
              10000
            )
            window.scroll(0, 0)
            this.cart.partialShipping = true
            this.shoppingCartService.setShippingType(true)
          } else if (success?.differentAvailabilityCode == 1002) {
            this.openEarliestShipDateDialog()
          }
        },
        (error) => {
          this.spinnerOverlayService.hide()
          this.globalMessageService.add(
            error,
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )
  }

  changeConsShipment(event) {
    const consValue = event.target.value
    this.cart.isConsolidatedShipment = JSON.parse(consValue)
    this.shoppingCartService.setConsolidatedShipment(JSON.parse(consValue))
    let consShipEntryErrors = []

    if (consValue == 'true') {
      for (const entry of this.items) {
        const weekDayName = moment(entry.customerRequestedDate).format('dddd')
        let selectedDay = this.cart.consolidatedDay
          ?.toLocaleLowerCase()
          .split(',')
        let weekDay = weekDayName.toLocaleLowerCase()
        if (!selectedDay.includes(weekDay)) {
          consShipEntryErrors.push(entry.entryNumber)
        }
      }
      if (consShipEntryErrors.length > 0) {
        // this.cart.isConsolidatedShipment = !this.cart.isConsolidatedShipment;
        this.shoppingCartService.setConsolidatedShipment(
          this.cart.isConsolidatedShipment
        )
        this.shoppingCartService.setConsErrors(consShipEntryErrors)
        this.scrollToEntry.emit(consShipEntryErrors[0])
        // this.consShipTrue.nativeElement.checked = !this.consShipTrue
        //   .nativeElement.checked;
        // this.consShipFalse.nativeElement.checked = !this.consShipFalse
        //   .nativeElement.checked;
        // return;
      }
    } else {
      this.consShipDateApplyError = false
      consShipEntryErrors = []
      this.shoppingCartService.setConsErrors(consShipEntryErrors)
    }

    this.spinnerOverlayService.show('Loading')
    this.shoppingCartService
      .changeShippingType(
        this.userId,
        this.cartId,
        this.cart.isConsolidatedShipment,
        false
      )
      .subscribe(
        (success: any) => {
          this.spinnerOverlayService.hide()
          this.shoppingCartService.setConsolidatedShipment(
            this.cart.isConsolidatedShipment
          )
          this.multiCartFacade.loadCart({
            cartId: this.cartId,
            userId: this.userType,
            extraData: {
              active: true,
            },
          })
        },
        (error) => {
          this.cart.isConsolidatedShipment = !this.cart.isConsolidatedShipment
          this.shoppingCartService.setConsolidatedShipment(
            this.cart.isConsolidatedShipment
          )
          this.spinnerOverlayService.hide()
          this.globalMessageService.add(
            { key: 'savedCart.errorChangingConsolidated' },
            GlobalMessageType.MSG_TYPE_WARNING,
            10000
          )
        }
      )
  }

  openEarliestShipDateDialog() {
    const componentdata = {
      earliestShipDate: this.getEarliestShipDate(this.cart),
    }

    const completeOrderDialog = this.launchDialogService.openDialog(
      VS_LAUNCH_CALLER.COMPLETE_ORDER,
      undefined,
      undefined,
      componentdata
    )
    if (completeOrderDialog) {
      completeOrderDialog.pipe(take(1)).subscribe((value) => {})
      this.launchDialogService.dialogClose
        .pipe(
          filter(
            (dialogResponse: DialogResponse) =>
              dialogResponse?.type == VS_LAUNCH_CALLER.COMPLETE_ORDER
          ),
          take(1)
        )
        .subscribe((value) => {
          if (value?.reason == 'success-order') {
            const shipdate = value?.data
            this.applyReqShipDate(shipdate)
          } else {
            this.cart.partialShipping = true
            this.shoppingCartService.setShippingType(this.cart.partialShipping)
          }
          this.cRef.detectChanges()
        })
    }
  }

  getEarliestShipDate(cartData) {
    const dates = []
    for (const entry of cartData.entries) {
      dates.push(entry.assignedShipDate)
    }
    const moments = dates.map((d) => moment(d))
    return moment(moment.max(moments)).format('YYYY/MM/DD')
  }

  openNonSellableDialog() {
    const componentdata = {
      nonSellableProducts: this.cart.vsNonSellableProducts,
    }

    const nonSellableDialog = this.launchDialogService.openDialog(
      VS_LAUNCH_CALLER.NON_SELLABLE,
      undefined,
      undefined,
      componentdata
    )
    if (nonSellableDialog) {
      nonSellableDialog.pipe(take(1)).subscribe((value) => {})
      this.launchDialogService.dialogClose
        .pipe(
          filter(
            (dialogResponse: DialogResponse) =>
              dialogResponse?.type == VS_LAUNCH_CALLER.NON_SELLABLE
          ),
          take(1)
        )
        .subscribe((value) => {
          if (value.reason == 'ok-non-sellable') {
            this.shoppingCartService
              .acknowledgeNonSellProducts(this.cartId)
              .subscribe(
                (res) => {
                  if (this.cartResponse?.entries?.length <= 0) {
                    this.deleteCart()
                  }
                },
                (error) => {
                  this.globalMessageService.add(
                    error,
                    GlobalMessageType.MSG_TYPE_ERROR,
                    5000
                  )
                  window.scrollTo(0, 0)
                }
              )
          }
          this.cRef.detectChanges()
        })
    }
  }

  updateSalesOrderCommmission(event) {
    this.shoppingCartService.soldToSelected(!this.commissionModel)
    if (this.commissionModel == false) {
      this.soldToAddress = null
    }
    this.spinnerOverlayService.show()
    this.shoppingCartService
      .saveOrderSalesCommission(this.cartId, this.commissionModel)
      .subscribe(
        (success) => {
          this.multiCartFacade.loadCart({
            cartId: this.cartId,
            userId: this.userType,
            extraData: {
              active: true,
            },
          })
          this.actions$
            .pipe(ofType(CartActions.LOAD_CART_SUCCESS))
            .pipe(take(1))
            .subscribe((r) => {
              this.spinnerOverlayService.hide()
              this.updateCart.emit(true)
            })
        },
        (err) => {
          this.commissionModel = !this.commissionModel
          this.cRef.detectChanges()
          this.globalMessageService.add(
            { key: 'savedCart.issueCommissionEligibility' },
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scroll(0, 0)
        }
      )
  }

  deleteCart() {
    this.multiCartFacade.deleteCart(this.cartId, this.userType)
  }
  setSoldToAddress(event) {
    this.shoppingCartService.soldToSelected(true)
    this.spinnerOverlayService.show()
    this.shoppingCartService
      .saveSalesCommissionUnit(this.cartId, event?.uid)
      .subscribe(
        (success) => {
          this.multiCartFacade.loadCart({
            cartId: this.cartId,
            userId: this.userType,
            extraData: {
              active: true,
            },
          })
          this.actions$
            .pipe(ofType(CartActions.LOAD_CART_SUCCESS))
            .pipe(take(1))
            .subscribe((r) => {
              this.spinnerOverlayService.hide()
              this.updateCart.emit(true)
            })
        },
        (error) => {}
      )
  }
  checkCompleteValidation() {
    const plant = this.cart.entries[0].plantAvailableAt.filter(
      (plant) => plant.defaultPlant
    )
    let count = 0
    this.cart.entries.map((entry) => {
      if (
        entry.plantAvailableAt.filter((plant) => plant.defaultPlant)[0]?.code !=
        plant[0]?.code
      )
        count++
    })

    if (count > 0) return false
    else return true
  }
}
